import { Typography, Box, Avatar } from '@mui/material';

const NetworkHospitalCard = ({ hospital = {}, idx }) => {
  return (
    <Box
      key={idx}
      backgroundColor='#fff'
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        pt: { xs: 1, md: 2 }, 
        borderRadius: 2,
      }}
    >
      <Box
        display='flex'
        gap={{ xs: 1, sm: 2 }}
        sx={{
          mt: 0,
          mb: { xs: 1, sm: 0 },
        }}
        
      >
        <Avatar
          src={hospital?.hospital_image_url || ''}
          alt={'Hospital Logo'}
          variant='rounded'
          sx={{
            width: 48,
            height: 43,
            backgroundColor: '#F7F7F7',
          }}
        />
        <Box>
          <Typography
            variant='labelD'
            // sx={{ mb: { xs: 0.5, sm: 1.5 } }}
          >
            {hospital?.name}
          </Typography>
          <Typography
            variant='p3'
            sx={{ color: '#666', minWidth: { xs: '120px', sm: '150px' } , lineHeight : '16px' }}
          >
            {hospital?.address}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              mb: 0.5,
            }}
          >
            <Typography
              variant='labelS'
              sx={{ color: '#666', mr: '8px' }}
            >
              Contact:
            </Typography>
            <Typography
              variant='p3'
              sx={{ color: '#333' }}
            >
              {hospital?.phone_number}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NetworkHospitalCard;
